import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, Phone } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ loading: true, paid: false });

  useEffect(() => {
    let attempts = 0;
    const poll = async () => {
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setState({ loading: false, paid: true });
          return;
        }
      } catch (e) {
        // keep polling
      }
      attempts += 1;
      if (attempts < 10) setTimeout(poll, 2000);
      else setState({ loading: false, paid: false });
    };
    if (sessionId) poll();
    else setState({ loading: false, paid: false });
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#081C15] grain-overlay flex items-center justify-center px-5">
      <div className="max-w-md w-full rounded-2xl bg-white/5 border border-white/15 p-10 text-center text-white" data-testid="payment-success-page">
        {state.loading ? (
          <>
            <Loader2 size={40} className="mx-auto text-[#D4AF37] animate-spin" />
            <h1 className="mt-6 font-display font-bold text-2xl">Confirming your payment...</h1>
            <p className="mt-3 text-sm text-[#D8E2DC]">This takes just a moment.</p>
          </>
        ) : state.paid ? (
          <>
            <CheckCircle2 size={40} className="mx-auto text-[#D4AF37]" />
            <h1 className="mt-6 font-display font-bold text-2xl" data-testid="payment-success-heading">Deposit received — thank you!</h1>
            <p className="mt-3 text-sm text-[#D8E2DC] leading-relaxed">
              Your down payment is confirmed. The IMR team will contact you shortly to
              schedule your barn cleaning. Remaining balance is due upon completion.
            </p>
          </>
        ) : (
          <>
            <Loader2 size={40} className="mx-auto text-[#D4AF37]" />
            <h1 className="mt-6 font-display font-bold text-2xl">Payment is processing</h1>
            <p className="mt-3 text-sm text-[#D8E2DC] leading-relaxed">
              We haven't received confirmation yet. If you completed the payment, it will
              appear shortly — or call us and we'll confirm for you.
            </p>
          </>
        )}
        <a
          href="tel:+19709023321"
          data-testid="payment-success-call"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#D4AF37] text-[#081C15] px-6 py-3 font-display font-bold text-sm hover:brightness-110 transition duration-200"
        >
          <Phone size={15} />
          1-970-902-3321
        </a>
        <div className="mt-6">
          <Link to="/" data-testid="payment-success-home" className="text-sm text-[#D8E2DC]/70 hover:text-white transition-colors duration-200">
            Back to homepage
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
